/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import Search from '@/components/Search/index.vue';
import {Meta} from '@/decorators';
import {MetaInfo} from 'vue-meta';
import IssuesList from '@/components/IssuesList/index.vue';
import GamesNavigation from '@/components/GamesNavigation/index.vue';
import SolveIssueInfo from '@/components/SolveIssueInfo/index.vue';
import {Action} from 'vuex-class';
import ContentBlock from '@/components/ContentBlock/index.vue';

/**
 * Home page view (component).
 *
 * @author Jenny Georgiadou <jgeorgiadou@frontier.co.uk>
 */
@Component({
    name: 'v-home',
    components: {
        'c-search': Search,
        'c-content-block': ContentBlock,
        'c-issues-list': IssuesList,
        'c-games-navigation': GamesNavigation,
        'c-solve-issue-info': SolveIssueInfo,
    },
})
export default class Home extends Vue {
    // Page Title
    @Action('updatePageTitle', {namespace: 'settingsModule'})
    public updatePageTitle!: (title: string) => void;
    // Update current view name in state
    @Action('updateCurrentView', {namespace: 'userSessionModule'})
    public updateCurrentView!: (view: {name: string, params?: any} | undefined) => void;

    private timeout: number = 0;

    /**
     * Meta generation.
     *
     *
     * This is an example cascaded meta generator for title and other met properties.
     *
     * @returns {MetaInfo}
     */
    @Meta
    public meta(): MetaInfo {
        const title: string = 'Home';

        return {
            title,
            meta: [
                {
                    property: 'og:title',
                    content: `${this.$i18n.translate('application.title', {}) || ''}`,
                },
                {
                    property: 'og:description',
                    content: 'Found a problem? Let\'s solve it.',
                },
                {
                    property: 'og:image',
                    content: window.location.hostname + '/img/og_image.jpg',
                },
            ],
        };
    }

    /**
     * Mounted lifecycle hook
     *
     */
    public mounted(): void {
        // Set the page title
        this.updatePageTitle(this.$i18n.translate('menu.header.title', {}) || '');

        // Update current view name in state
        this.updateCurrentView({name: this.$router.currentRoute.name || 'home'});

        // For the scroll effect
        window.clearTimeout(this.timeout);
        // Is it has hash then scroll to hash anchor
        if (this.$router.currentRoute.hash) {
            // Scroll to anchor
            const element: HTMLElement | null = document.getElementById(this.$router.currentRoute.hash);
            if (null !== element) {
                // Timeout to give time to page to load properly and scroll to correct location
                this.timeout = window.setTimeout(async () => {
                    element.scrollIntoView({
                        behavior: 'smooth',
                    });
                }, 500);
            }
        }
    }
}
